export enum ArabicOrdinal {
  الأول,
  الثاني,
  الثالث,
  الرابع,
  الخامس,
  السادس,
  السابع,
  الثامن,
  التاسع,
  العاشر,
}

export enum EnglishOrdinal {
  one,
  two,
  three,
  four,
  five,
  six,
  seven,
  eight,
  nine,
  ten,
}

export enum DaysOfWeek {
  Sunday,
  Monday,
  Tuesday,
  Wednesday,
  Thursday,
  Friday,
  Saturday,
}

export enum DaysOfWeekAr {
  الاحد,
  الاثنين,
  الثلاثاء,
  الاربعاء,
  الخميس,
  الجمعة,
  السبت,
}

export enum branchesAvilability {
  'AVAILABLE', // you can make orders at this time     0
  'NOT_OPEN', // open = false                          1
  'NOT_OPENING_DAY', // isOpeningDay = false           2
  'NOT_OPENING_TIME' // not available time period      3
}